import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnFI: CultureInfo = {
  name: 'en-FI',
  displayName: 'English (Finland)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-FI',
  parent: CultureInfoEn
};
